import PageHeader from "@/components/layout/PageHeader";
import ServicesSection from "@/components/sections/ServicesSection";
import FaqAndCampaigns from "@/components/sections/FaqAndCampaigns";
import QuickQuoteForm from "@/components/sections/QuickQuoteForm";
import { SERVICES } from "@/data/site";
import {
  Flame, Cpu, Layers, Wrench, Stethoscope, BatteryCharging, Activity, Droplet, Settings2, Cog,
} from "lucide-react";

const ICONS = { Flame, Cpu, Layers, Wrench, Stethoscope, BatteryCharging, Activity, Droplet, Settings2, Cog };

export default function ServicesPage() {
  return (
    <div data-testid="services-page">
      <PageHeader
        eyebrow="Hizmetlerimiz"
        title="LPG, akü ve bakımın"
        accent="tam donanımlı adresi."
        subtitle="Tek bir ziyarette tüm ihtiyaçlarınız çözülür: LPG montajı, bilgisayarlı ayar, akü değişimi, yağ bakımı ve daha fazlası."
      />

      <ServicesSection withHeader={false} />

      {/* Detailed list */}
      <section className="py-20 bg-[#050A1F] relative overflow-hidden">
        <div className="absolute inset-0 bg-blueprint opacity-25" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-12 max-w-2xl">
            <p className="text-gold uppercase tracking-[0.4em] text-xs mb-3">
              Detaylı Hizmet
            </p>
            <h2 className="font-display text-3xl sm:text-5xl font-bold text-balance">
              <span className="text-gradient-silver">Her hizmet, </span>
              <span className="text-gradient-gold">en ince ayrıntıya kadar.</span>
            </h2>
          </div>

          <div className="space-y-3">
            {SERVICES.map((s, i) => {
              const Icon = ICONS[s.icon] || Settings2;
              return (
                <div
                  key={s.slug}
                  data-testid={`service-detail-${s.slug}`}
                  className="glass rounded-2xl p-6 sm:p-8 grid lg:grid-cols-[auto_1fr_auto] gap-6 items-center hover:border-gold/40 transition-all"
                >
                  <div className="flex items-center gap-4">
                    <div className="font-display text-3xl font-bold text-gold/40 w-10">
                      {String(i + 1).padStart(2, "0")}
                    </div>
                    <div className="w-12 h-12 rounded-xl bg-gold/10 border border-gold/30 flex items-center justify-center">
                      <Icon className="w-5 h-5 text-gold" />
                    </div>
                  </div>
                  <div>
                    <h3 className="font-display font-semibold text-xl text-white mb-1.5">
                      {s.title}
                    </h3>
                    <p className="text-white/65 text-sm leading-relaxed">{s.long}</p>
                  </div>
                  <ul className="flex flex-wrap gap-2 lg:flex-col lg:flex-nowrap lg:max-w-[200px]">
                    {s.bullets.map((b) => (
                      <li
                        key={b}
                        className="text-[11px] px-2.5 py-1 rounded-full bg-gold/10 border border-gold/30 text-gold uppercase tracking-wider font-medium"
                      >
                        {b}
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <FaqAndCampaigns />
      <QuickQuoteForm />
    </div>
  );
}
